module.exports = __webpack_public_path__ + "img/maximise.651b9407.svg";